import { useEffect, useState, type ReactNode } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { NoteComposerDialog } from "./NoteComposerDialog"
import { AccountMenu } from "./AccountMenu"
import { MobileNavigation, Sidebar } from "./Navigation"
import { Icon } from "./Icon"
import { Toasts } from "./Toasts"

export interface AppShellProps {
  children?: ReactNode
}

/**
 * Application shell: desktop sidebar, mobile bottom navigation, global compose
 * dialog and toasts. The routed page renders in `<main>`.
 */
export function AppShell({ children }: AppShellProps) {
  const location = useLocation()
  const [composeOpen, setComposeOpen] = useState(false)
  const [accountOpen, setAccountOpen] = useState(false)

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior })
  }, [location.pathname])

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <Sidebar onCompose={() => setComposeOpen(true)} onAccount={() => setAccountOpen(true)} />
      <main id="main-content" className="app-main" tabIndex={-1}>
        {children ?? <Outlet />}
      </main>
      <MobileNavigation onAccount={() => setAccountOpen(true)} />
      <button
        type="button"
        className="mobile-compose"
        onClick={() => setComposeOpen(true)}
        aria-label="Publish a note"
      >
        <Icon name="pen" size={22} />
      </button>

      <NoteComposerDialog open={composeOpen} onClose={() => setComposeOpen(false)} />
      <AccountMenu open={accountOpen} onClose={() => setAccountOpen(false)} />
      <Toasts />
    </div>
  )
}
